var map = {
	"./1.jpg": 8006,
	"./10.jpg": 2704,
	"./11.jpg": 5971,
	"./12.jpg": 9928,
	"./13.jpg": 5215,
	"./14.jpg": 4171,
	"./15.jpg": 8767,
	"./16.jpg": 6394,
	"./17.jpg": 9537,
	"./18.jpg": 7532,
	"./2.jpg": 4761,
	"./3.jpg": 5835,
	"./4.jpg": 9803,
	"./5.jpg": 9571,
	"./6.jpg": 8579,
	"./7.jpg": 4976,
	"./8.jpg": 9225,
	"./9.jpg": 5528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8083;